import Abrechnung from "./abrechnung";
import AbrechnungV2 from "./abrechnung_v2";
import Reisekostenabrechnung from "./reisekostenabrechnung";
import ReisekostenabrechnungV2 from "./reisekostenabrechnung_v2";

function withServerPdf(abrechnung, data) {
    abrechnung.serverPdf = data.serverPdf || null
    return abrechnung
}

const abrechnungConverter = {
    toFirestore: (abrechnung) => {
        return abrechnung.toFirestore()
    },
    fromFirestore: (snapshot, options) => {
        const data = snapshot.data(options);
        if(data.type == 'Reisekostenabrechnung' && data.v2 === true){
            return withServerPdf(new ReisekostenabrechnungV2(
                snapshot.id,
                data.versionId,
                data.empfaenger,
                data.abrechnender,
                data.reisezweck,
                data.reise_angeordnet,
                data.reisebeginn,
                data.reiseende,
                data.reisestart,
                data.reiseziel,
                data.wegpunkte,
                data.routetype,
                data.fahrtkosten,
                data.ausgaben,
                data.auslagen,
                data.uebernachtungsgelder,
                data.status,
                data.freigaben,
                data.historie,
                data.anmerkungen,
                data.kostenstelle,
                data.kostentraeger,
                data.printed,
                data.kreditorennummer,
                data.tags
            ), data)
        }
        else if(data.type == 'Reisekostenabrechnung'){
            return withServerPdf(new Reisekostenabrechnung(
                snapshot.id,
                data.versionId,
                data.empfaenger,
                data.abrechnender,
                data.reisezweck,
                data.reise_angeordnet,
                data.reisebeginn,
                data.reiseende,
                data.reisestart,
                data.reiseziel,
                data.wegpunkte,
                data.routetype,
                data.fahrtkosten,
                data.nebenkosten,
                data.auslagen,
                data.uebernachtungsgelder,
                data.status,
                data.freigaben,
                data.historie,
                data.anmerkungen,
                data.kostenstelle,
                data.kostentraeger,
                data.printed,
                data.kreditorennummer,
                data.tags
            ), data)
        }
        else if(data.v2 === true){
            return withServerPdf(new AbrechnungV2(
                snapshot.id,
                data.versionId,
                data.empfaenger,
                data.abrechnender,
                data.reisekosten,
                data.ausgaben,
                data.pauschalen,
                data.status,
                data.freigaben,
                data.zeitraum,
                data.type,
                data.historie,
                data.anmerkungen,
                data.kostenstelle,
                data.kostentraeger,
                data.printed,
                data.kreditorennummer,
                data.tags
            ), data)
        }
        return withServerPdf(new Abrechnung(
            snapshot.id,
            data.versionId,
            data.empfaenger,
            data.abrechnender,
            data.reisekosten,
            data.portokosten,
            data.telefonkosten,
            data.sonstige_kosten,
            data.status,
            data.freigaben,
            data.zeitraum,
            data.type,
            data.historie,
            data.anmerkungen,
            data.kostenstelle,
            data.kostentraeger,
            data.printed,
            data.kreditorennummer,
            data.tags
        ), data)
    }
}

export default abrechnungConverter
